/* eslint-disable no-underscore-dangle */

'use-strict';

import { IScope } from 'angular';
import { PrintAPIService } from 'shared/api/print-api.service';
import { TabService } from 'shared/browser-functions/tab.service';
import { ConfigService } from 'shared/config/config.service';
import { NumberConversionService } from 'shared/converter/number-converter.service';
import { IPricingStickerExtra, PricingStickerRequest } from 'src/app/@shared-types/print';
import { AutoboardVehicle } from 'src/app/@shared-types/vehicle';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';

interface PricingStickerFormScope extends IScope {
  vehicle: AutoboardVehicle,
  sending: boolean,
  locations: { [key: string]: string } | null,
  exitForm: () => void,
  exit: (data: VehicleFormComponentExitFunction) => void,
  valuesChanged: () => void,
  formTransmission: () => void,
  pricingSticker: {
    validDate: string | null,
    extras: { title: string, price: string }[],
    validNotification: boolean,
    price: string,
    showFinancingExample: boolean,
    showRrp: boolean,
    featuresToShow: 'OPTIONS' | 'DETAILED',
  }
}

/* @ngInject */
export default function PricingStickerFormController(
  $scope: PricingStickerFormScope,
  tabService: TabService,
  numberConversionService: NumberConversionService,
  printApiService: PrintAPIService,
  configService: ConfigService,
  toastService: ToastService,
): void {
  $scope.sending = false;
  $scope.locations = configService.get('general_locations');

  $scope.exitForm = () => $scope.exit({ removeLock: false });

  $scope.formTransmission = async () => {
    $scope.sending = true;

    const parsedExtras: IPricingStickerExtra[] = [];
    $scope.pricingSticker.extras
      .forEach((e) => parsedExtras.push({
        price: numberConversionService.parseStringFloat(e.price),
        title: e.title,
      }));

    const stickerRequest: PricingStickerRequest = {
      extras: parsedExtras,
      price: numberConversionService.parseStringFloat($scope.pricingSticker.price),
      vatRate: $scope.vehicle.vehicleData.price.vatRate || 0.19,
      vehicleId: $scope.vehicle._id,
      showFinancingExample: $scope.pricingSticker.showFinancingExample,
      featuresToShow: $scope.pricingSticker.featuresToShow,
    };

    if ($scope.pricingSticker.validDate) {
      stickerRequest.validDate = numberConversionService
        .frontendStringToDate($scope.pricingSticker.validDate);
      stickerRequest.validNotification = $scope.pricingSticker.validNotification;
    }

    const vat = (1 + stickerRequest.vatRate);

    if ($scope.vehicle.vehicleData.price.retailPrices.offer) {
      stickerRequest.rrp = $scope.vehicle.vehicleData.price.retailPrices.offer * vat;
    } else if ($scope.vehicle.vehicleData.price.retailPrices.invoice) {
      stickerRequest.rrp = $scope.vehicle.vehicleData.price.retailPrices.invoice * vat;
    } else if ($scope.vehicle.vehicleData.price.retailPrices.manufacturer) {
      stickerRequest.rrp = $scope.vehicle.vehicleData.price.retailPrices.manufacturer * vat;
    }

    if (!$scope.pricingSticker.showRrp) {
      stickerRequest.rrp = undefined;
    }

    printApiService.getPricingSticker(stickerRequest)
      .then((stickerHtml) => {
        tabService.openTabWithHTML(stickerHtml.data, `Preisschild-${$scope.vehicle._id}`, true);
        $scope.sending = false;
        $scope.exit({});
      })
      .catch(() => {
        toastService.toast(ToastType.ERROR, 'Fehler beim Erstellen des Preisschilds');
        $scope.sending = false;
        $scope.exit({});
      });
  };

  const init = () => {
    const extras: { title: string, price: string }[] = [];

    const price = numberConversionService
      .convertFloatToFrontend($scope.vehicle.vehicleData.price.campaignPrice || 0);

    if ($scope.vehicle.vehicleData.price.includesTransferCosts) {
      let transferCosts = $scope.vehicle.vehicleData.price.transferCosts || 0;
      const vatRate = $scope.vehicle.vehicleData.price.vatRate || 0.19;
      if ($scope.vehicle.vehicleData.price.includesVat) transferCosts *= (1 + vatRate);

      extras.push({
        title: 'Überführungskosten',
        price: numberConversionService.convertFloatToFrontend(transferCosts, true),
      });
    }

    $scope.pricingSticker = {
      price,
      extras,
      validDate: null,
      validNotification: false,
      showFinancingExample: false,
      showRrp: true,
      featuresToShow: 'OPTIONS',
    };

    // $scope.valuesChanged();
  };

  init();
}
